import { useEffect } from 'react';

import { useVSliderContext } from '../VSlider/hook';
import { changeFilledTrackEl, getFilledTrackElByValue } from '../VSlider/util';
import { new__cn as cn } from '../util';
import { useVFrameTrackSliderContext } from './hook';

const ariaLabel = 'v-cached-range-filled-track';

const START_TRACK_OFFSET = -4;
const END_TRACK_OFFSET = 8;

export const VCachedRangeFilledTrackList = () => {
  const { normalizedMarkerItemMap, min, style, $track } = useVSliderContext();
  const { normalizedCachedRangeValue: normalizedValue } =
    useVFrameTrackSliderContext();

  useEffect(() => {
    if (!$track.current || !normalizedMarkerItemMap) return;

    normalizedValue.forEach(([start, end]) => {
      const $filledTrack = getFilledTrackElByValue($track, end);

      if (
        !$filledTrack ||
        !normalizedMarkerItemMap[end] ||
        !normalizedMarkerItemMap[start]
      )
        return;

      changeFilledTrackEl({
        $filledTrack,
        endLeft: normalizedMarkerItemMap[end].left.track + END_TRACK_OFFSET,
        startLeft:
          normalizedMarkerItemMap[start].left.track + START_TRACK_OFFSET,
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [normalizedMarkerItemMap, normalizedValue]);

  return (
    <>
      {normalizedValue.map(([start, end], i) => {
        if (end == null) {
          [start, end] = [min, start];
        }

        return (
          <div
            key={i}
            aria-label={ariaLabel}
            aria-valuemax={end}
            aria-valuemin={start}
            className={cn(
              style.filledTrack,
              'after:bg-gray-300',
              'after:h-scale/8',
              'after:top-0',
              'z-1',
              'hover:after:bg-gray-300',
            )}
            style={
              {
                '--endLeft': 0,
                '--startLeft': 0,
              } as React.CSSProperties
            }
          />
        );
      })}
    </>
  );
};

VCachedRangeFilledTrackList.displayName = 'VCachedRangeFilledTrackList';
